/**
 * FitSmith Pakketconfiguratie
 * Centraal bestand voor plan-features en menu-volgorde.
 */

export const PLAN_FEATURES = {
  basic: [
    "dashboard", "activiteit", "sporters", "intake",
    "schemas", "voeding", "bibliotheek", "instellingen"
  ],
  pro: [
    "dashboard", "activiteit", "sporters", "intake",
    "schemas", "voeding", "bibliotheek", "instellingen",
    "rooster", "mappen", "templates", "credits", "analytics"
  ],
  business: [
    "dashboard", "activiteit", "sporters", "intake",
    "schemas", "voeding", "bibliotheek", "instellingen",
    "rooster", "mappen", "templates", "credits", "analytics",
    "abonnement", "personeel", "beheerders", "facturen", "community"
  ],
};

// Volgorde zoals opgegeven (features die niet in het plan zitten worden VERBORGEN)
export const MENU_ORDER = [
  "dashboard",
  "activiteit",
  "sporters",
  "intake",
  "schemas",
  "voeding",
  "rooster",
  "mappen",
  "bibliotheek",
  "templates",
  "credits",
  "abonnement",
  "personeel",
  "beheerders",
  "community",
  "facturen",
  "analytics",
  "instellingen",
];

export const PLAN_INFO = {
  basic: {
    naam: "Basic",
    prijs: 59.95,
    kleur: "#6366f1",
    max_sporters: 10,
    doelgroep: "Zelfstandige personal trainers en startende coaches",
    hoogtepunten: [
      "Maximaal 10 sporters",
      "Schema-builder",
      "Voedingsmodule",
      "Intake formulieren",
    ],
  },
  pro: {
    naam: "Pro",
    prijs: 109.95,
    kleur: "#C9A84C",
    max_sporters: 40,
    doelgroep: "Groeiende coaches en kleine sportscholen",
    hoogtepunten: [
      "Maximaal 40 sporters",
      "Rooster & boekingssysteem",
      "Credits & betaalpakketten",
      "Mappen & templates",
      "Analytics",
    ],
  },
  business: {
    naam: "Business",
    prijs: 168.95,
    kleur: "#10b981",
    max_sporters: 75,
    doelgroep: "Sportscholen en organisaties met meerdere coaches",
    hoogtepunten: [
      "Maximaal 75 sporters",
      "Personeel & beheerders",
      "Facturatie (PDF)",
      "Community feed",
      "Uitgebreide analytics",
    ],
  },
};

export const FEATURE_PLAN_MAP = {
  // Welk plan is minimaal nodig voor een feature?
  dashboard:    "basic",
  activiteit:   "basic",
  sporters:     "basic",
  intake:       "basic",
  schemas:      "basic",
  voeding:      "basic",
  bibliotheek:  "basic",
  instellingen: "basic",
  rooster:      "pro",
  mappen:       "pro",
  templates:    "pro",
  credits:      "pro",
  analytics:    "pro",
  abonnement:   "business",
  personeel:    "business",
  beheerders:   "business",
  facturen:     "business",
  community:    "business",
};

export const PLAN_HIERARCHY = ["basic", "pro", "business"];

export function getMinimumPlanForFeature(feature) {
  return FEATURE_PLAN_MAP[feature] || "basic";
}

export function isFeatureAllowed(feature, plan) {
  const allowed = PLAN_FEATURES[plan] || PLAN_FEATURES.basic;
  return allowed.includes(feature);
}

export function getNextPlanForFeature(feature, currentPlan) {
  const required = FEATURE_PLAN_MAP[feature] || "basic";
  return required;
}
